import type {
  DecoratedNote,
  DecoratedUnisonProject,
  DecoratedUnisonProjectNote,
  UnisonProjectTypeId,
} from '@witmetrics/utils';
import { isBlank } from '@witmetrics/utils/strings';
import type { BaseOption } from '@witmetrics/unison-core';
import { API } from '@/api';

export const classes = {
  dialog: 'w-[98vw] max-w-[1000px] min-w-[500px]',
  body: 'w-full max-h-[80vh] min-h-[100px] pt-2 pb-12 overflow-auto',
  section: 'w-full max-w-[500px]',
  dropdown: 'w-full my-2',
  textField: 'w-full my-2',
  notes: 'w-full mt-2 mb-8',
};

export function validateFields({
  name,
  projectType,
  userId,
}: {
  name: string;
  projectType: BaseOption | null;
  userId?: number;
}) {
  let invalidFields = [];
  if (isBlank(name) && !userId) invalidFields.push('name');
  if (!projectType) invalidFields.push('projectType');
  return invalidFields;
}

export async function createUnisonProject(
  data: {
    name: string;
    description: string;
    userId?: number;
  },
  notes: string
): Promise<{
  project: DecoratedUnisonProject;
  note?: DecoratedNote;
  projectNote?: DecoratedUnisonProjectNote;
}> {
  if (notes.length > 0) {
    const [project, note] = await Promise.all([
      API.UnisonProjects.createNewProject(data),
      API.Notes.createNewNote({ content: notes.trim() }),
    ]);
    const projectNote = await API.UnisonProjects.addNoteToUnisonProject(
      project.id,
      note.id
    );
    return { project, note, projectNote };
  } else {
    const project = await API.UnisonProjects.createNewProject(data);
    return { project };
  }
}

export function updateProject(
  projectId: number,
  data: {
    name: string;
    externalRef: string;
    description: string;
    userId?: number;
    unisonProjectTypeId?: UnisonProjectTypeId;
  }
) {
  return API.UnisonProjects.updateUnisonProject(projectId, data);
}
